(function () {
    $(function () {
        if (!$.cookie('isCookieConfirm')) {
            const $body = $('body')

            const $messageCookies = $('.message-cookies').appendToBottomWrapper()
            $messageCookies.addClass('_show')
            $body.addClass('body_global-hasBottomBar')

            $messageCookies.find('.message-cookies__btn').on('click', event => {
                event.preventDefault()
                $.cookie('isCookieConfirm', true, {
                    expires: 365,
                    path: '/'
                })
                $body.removeClass('body_global-hasBottomBar')
                $messageCookies.removeClass('_show').detachFromBottomWrapper()
                
                // Событие скрытия плашки
                document.dispatchEvent(new CustomEvent('ab.message.cookies.hide', {
                    bubbles: true,
                    cancelable: true,
                }));
            });
        }
    });
})();
